/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { CSV_EXPORT_PATH, withApiQuery } from "../../../utils/reportExport";

/**
 * Where the Group Labor Summary is downloaded from, in either format.
 *
 * PDF and CSV are built from the same server-side document builder, so the two formats and the
 * table on screen can never disagree about a number. Only the URLs differ, which is all this
 * module holds — the download machinery itself is shared in utils/reportExport.
 *
 * Group level only: this report has no per-restaurant drill-in, so one document is the whole
 * surface. Both endpoints cover the WHOLE filtered scope rather than the page on screen, which is
 * also why the exported Total is the sum of the exported rows.
 */
export const buildGroupExportUrl = ({ format, businessDate, scope = {} }) =>
  format === "csv"
    ? withApiQuery(CSV_EXPORT_PATH, {
        report: "labor_report",
        business_date: businessDate,
        ...scope,
      })
    : withApiQuery("/v1/admin/labor_reports/export", {
        business_date: businessDate,
        ...scope,
      });

/**
 * Fallback name, used only when a response carries no Content-Disposition. Both endpoints name
 * their own file, and the PDF names itself after its masthead title, which the client does not
 * have — so this is the date an operator sorts by and nothing more.
 */
export const exportFilename = ({ format, businessDate }) => {
  const date = businessDate ? `-${businessDate}` : "";

  return `labor-report${date}.${format}`;
};
